import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectVirtualCardIdFromRoute } from 'src/app/UpdateVirtualCardForm/redux/updateVirtualCardForm.selectors'
import UpdateVirtualCardForm from 'src/app/UpdateVirtualCardForm/UpdateVirtualCardForm'
import { UpdateVirtualCardScreen } from 'src/app/UpdateVirtualCardForm/UpdateVirtualCardScreen'
import RightFlyout, {
  RightFlyoutBodyWidths,
} from 'src/components/RightFlyout/RightFlyout'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { updateVirtualCardUrl } from 'src/navigation/urls'
import { useQueryUser } from 'src/queries/users.queries'
import {
  useQueryVirtualCardDetail,
  useQueryVirtualCardPermissions,
} from 'src/queries/virtualCards.queries'

const UpdateBillPay: React.FC = () => {
  const dispatch = useFlyoutDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const { data: virtualCard, isLoading: isVirtualCardLoading } =
    useQueryVirtualCardDetail({ virtualCardId })
  const { data: virtualCardPermissions, isLoading: isPermissionsLoading } =
    useQueryVirtualCardPermissions({ virtualCardId })
  const { data: recipient, isLoading: isRecipientLoading } = useQueryUser({
    userId: virtualCard?.recipientId,
  })
  const { data: cardholder, isLoading: isCardholderLoading } = useQueryUser({
    userId: virtualCard?.cardholderId,
  })

  useEffect(() => {
    if (virtualCard === undefined) return

    if (!virtualCard.isBillPay) {
      // user is trying to access a regular virtual card, redirect to the virtual card url
      dispatch(connectedReplace(updateVirtualCardUrl(virtualCardId)))
    }
  }, [virtualCard])

  return (
    <RightFlyout width={RightFlyoutBodyWidths.Action}>
      <UpdateVirtualCardForm
        screen={UpdateVirtualCardScreen.BillPay}
        virtualCardId={virtualCardId}
        virtualCard={virtualCard}
        virtualCardPermissions={virtualCardPermissions}
        recipient={recipient}
        cardholder={cardholder}
        loadingFlyout={
          isVirtualCardLoading ||
          isPermissionsLoading ||
          isRecipientLoading ||
          isCardholderLoading
        }
      />
    </RightFlyout>
  )
}

export default UpdateBillPay
